<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-date-picker
        class="screenInput"
        v-model="screen.create_time"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择登记时间"
      >
      </el-date-picker>
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入预约人"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入预约人手机号"
      ></el-input>
      <el-input
        v-if="type == 2"
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入预约公司名称"
      ></el-input>
      <el-date-picker
        class="screenInput"
        v-model="screen.start_time"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择预约开始时间"
      >
      </el-date-picker>
      <el-date-picker
        class="screenInput"
        v-model="screen.end_time"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择预约结束时间"
      >
      </el-date-picker>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
      <el-button
        type="warning"
        @click="listsExport()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/station_make/lists_export')"
        >导出</el-button
      >
    </div>
    <el-tabs v-model="type" type="card" @tab-click="typeHandel">
      <el-tab-pane label="个人工位" name="1">
        <el-table
          max-height="700"
          v-loading="listLoading"
          :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          :data="list"
          element-loading-text="Loading"
          fit
          highlight-current-row
          stripe
          class="table-box"
          tooltip-effect="dark"
          row-key="id"
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>

          <el-table-column label="所属园区" align="center" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.park ? scope.row.park.name : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工位号" align="center" min-width="100">
            <template slot-scope="scope">
              <span>{{
                scope.row.station ? scope.row.station.number : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工单类型" align="center" width="80">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.type == 1 ? '' : 'success'"
                disable-transitions
              >
                {{ scope.row.type == 1 ? "个人" : "房间" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="预约人" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.name || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系电话" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.phone || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="免费天数" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.station ? scope.row.station.free_day : "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="租赁费用" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.price || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="开始时间" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.start_time || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="结束时间" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.end_time || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="变更记录"
            min-width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="changeInfo(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- <el-tab-pane label="房间工位" name="2">
        <el-table
          max-height="700"
          v-loading="listLoading"
          :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          :data="list"
          element-loading-text="Loading"
          fit
          highlight-current-row
          stripe
          class="table-box"
          tooltip-effect="dark"
          row-key="id"
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">
              {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>

          <el-table-column label="所属园区" align="center" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.park ? scope.row.park.name : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工位号" align="center" min-width="100">
            <template slot-scope="scope">
              <span>{{
                scope.row.station ? scope.row.station.number : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工单类型" align="center" width="80">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.type == 1 ? '' : 'success'"
                disable-transitions
              >
                {{ scope.row.type == 1 ? "个人" : "房间" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="预约人" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.name || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系电话" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.phone || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="公司名称" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.company_name || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="租赁费用" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.price || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="开始时间" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.start_time || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="结束时间" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.end_time || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="变更记录"
            min-width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="changeInfo(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> -->
    </el-tabs>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog
      title="变更记录"
      :visible.sync="changeVisable"
      width="900px"
      custom-class="changeData"
      :destroy-on-close="true"
    >
      <el-table
        :data="changeData"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        stripe
        height="40vh"
        style="width: 100%"
      >
        <el-table-column label="工位号" width="150px">
          <template slot-scope="scope">
            {{ scope.row.station ? scope.row.station.number : "--" }}
          </template>
        </el-table-column>
        <el-table-column label="预约人" min-width="100px">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="100px"
          v-if="changeType == 2"
        >
          <template slot-scope="scope">
            {{ scope.row.company_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="开始时间" width="130px">
          <template slot-scope="scope">
            {{ scope.row.start_time || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="130px">
          <template slot-scope="scope">
            {{ scope.row.end_time || "--" }}
          </template>
        </el-table-column>
        <el-table-column width="100px" label="金额">
          <template slot-scope="scope">
            {{ scope.row.price || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="收费状态" align="center" width="80">
          <template slot-scope="scope" v-if="scope.row.order">
            <el-tag
              v-if="scope.row.order.order_status == 1"
              type="danger"
              disable-transitions
            >
              待付款</el-tag
            >
            <el-tag
              v-else-if="scope.row.order.order_status == 2"
              type="success"
              disable-transitions
            >
              付款成功</el-tag
            >
            <el-tag
              v-else-if="scope.row.order.order_status == 3"
              type="danger"
              disable-transitions
            >
              付款失败</el-tag
            >
            <el-tag
              v-else-if="scope.row.order.order_status == 4"
              type="info"
              disable-transitions
            >
              取消支付</el-tag
            >
            <el-tag
              v-else-if="scope.row.order.order_status == 5"
              type="warning"
              disable-transitions
            >
              已退款</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column min-width="160px" label="变更日期">
          <template slot-scope="scope">
            {{ scope.row.create_time || "--" }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, delImage } from "@/api/index";
import {
  stationReservationListed,
  record_lists,
  lists_export,
} from "@/api/sharedOffice";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      type: "1",
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        create_time: "",
        name: "",
        phone: "",
        company_name: "",
        start_time: "",
        end_time: "",
      },
      typeList: [],
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      changeVisable: false,
      changeData: [],
      changeType: "1",
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    listsExport() {
      const loading = this.$loading({
        lock: true,
        text: "数据量过大，正在导出中...",
        spinner: "el-icon-loading",
      });
      lists_export(this.screen)
        .then((res) => {
          loading.close();
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = res.name;
          // downloadElement.target="_blank"
          downloadElement.setAttribute("target", "_blank");
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((error) => {
          console.log(error);
          loading.close();
        });
    },
    // 类型切换
    typeHandel() {
      this.screen.page = 1;
      this.screen.total = 0;
      this.list = [];
      this.fetchData();
    },
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        create_time: "",
        name: "",
        phone: "",
        company_name: "",
        start_time: "",
        end_time: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.drawer = false;
      this.registerDrawer = false;
      this.userDrawer = false;
    },
    fetchData() {
      this.listLoading = true;
      stationReservationListed({ ...this.screen, type: this.type }).then(
        (response) => {
          this.list = response.data.lists.data;
          this.total = response.data.lists.total;
          this.listLoading = false;
        }
      );
    },
    changeInfo(row) {
      record_lists({ station_make_total_id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.changeType = row.type;
            this.changeData = res.data.lists;
            this.changeVisable = true;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "请求出错",
            type: "error",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .changeData {
  .el-dialog__body {
    padding-top: 10px;
  }
}
::v-deep .userDialog .el-dialog__body {
  padding-top: 10px;
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px 10px 0;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
